/* eslint-disable import/prefer-default-export */
import { cls } from "cls";

export const filterRangeInputStyles = (showSelect: boolean) => {
  return cls(
    "pl-2 py-2.5 appearance-none-number shadow-none border-gray-400 h-10 lt:h-6 w-full",
    { "lt:w-[54px]": showSelect }
  );
};

export const filterRangeInputContainerStyles = (showSelect: boolean) => {
  return cls("flex-grow", "pb-1.5", !showSelect ? "w-full" : "lt:max-w-[54px]");
};

export const filterRangeInputLabelStyles = cls(
  "text-sm",
  "lt:text-xs",
  "mb-0",
  "text-gray-800"
);

export const filterRangeInputInlineStyles = {
  backgroundColor: "transparent",
  border: "1px solid #CF3700",
  boxShadow: "0px 0px 0px 2px #FED7D7",
};
